import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  scrollBehavior(ruta) {
    if (ruta.name == "gracias") {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
